import axios from 'axios'
import { axiosPublic } from '../../plugins/http-client/axios'
import MessageBus from '../buses/MessageBus'
import { DocumentData, DocumentFields, ImagePost } from '../../types/images'

/**
 *
 * @param {Object} fileUploaded file to be put into s3 bucket
 */
const uploadDocument = async (fileUploaded: DocumentData, numberOfFiles: Number, isLastImage: boolean, typeOfDoc: string) => {
  // Send the filename and type to the server to generate a presigned URL
  try {
    let file = {
      file: {
        name: fileUploaded.name,
        type: fileUploaded.type
      }
    }
    const res = await axios.put('/documents/presigned', file)
    const documentUrl: string = res.data.data.document_url
    const postData: ImagePost = res.data.data.postData
    const url: string = res.data.data.postData.url

    const formData = new FormData()
    Object.keys(postData.fields).forEach((key: string) => {
      const value = postData.fields[key as keyof DocumentFields]
      formData.append(key, value)
    })

    // file must be appended last
    formData.append('file', <any>fileUploaded as Blob)

    // s3 post object does not return anything on success
    await axiosPublic.post(
      url,
      formData
    )

    console.log('res: ', res.data.data)

    if (isLastImage) {
      let determinePlural = numberOfFiles > 1 ? typeOfDoc + 's' : typeOfDoc
      MessageBus.sendMessage(`Woohoo! ${numberOfFiles} ${determinePlural} successfully uploaded.`, 'success')
    }

    // return fileUrl
    console.log('url', documentUrl)
    return documentUrl
  } catch (err) {
    console.log('Error Uploading Image', err)
    MessageBus.sendMessage('Uh oh. Looks like something went wrong uploading this document.', 'error')
  }
}

export {
  uploadDocument
}
